// extracted by mini-css-extract-plugin
export default {"grade":"Duvidas_grade__0ofKT","topo":"Duvidas_topo__YQNZO","lista":"Duvidas_lista__p4E3k","item":"Duvidas_item__iKZ3p","sinal":"Duvidas_sinal__fcKru"};